import { Component } from "@angular/core";

@Component({
    selector: 'icon-stop[ui-kit]',
    template: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.5" y="3.5" width="13" height="13" rx="2.5" fill="currentColor"/>
    </svg>
    `,
})
export class IconStop {}
